import { o as S } from "./index-DA7LeYY4.js";
import { ref as c, watch as v, onMounted as y, nextTick as z, onUnmounted as N } from "vue";
class B {
  el;
  callback;
  constructor(f, r, l) {
    this.el = f, this.callback = r, this.el.addEventListener("scroll", () => {
      this.callback();
    }), window.addEventListener("beforeunload", () => {
      this.destroy();
    });
  }
  destroy() {
    this.el.removeEventListener("scroll", () => {
      this.callback();
    });
  }
}
const n = (u) => `${u}px`, j = (u, f) => {
  const r = c(null), l = c(null), h = c("top-left"), b = c();
  v(h, () => {
    l.value && (l.value.dataset.position = h.value);
  });
  const L = (t, i) => {
    const e = window.innerHeight, s = window.innerWidth, o = t;
    return {
      "top-left": () => ({ bottom: n(e - o.top), right: n(s - o.right) }),
      "top-right": () => ({ bottom: n(e - o.top), left: n(o.left) }),
      "bottom-left": () => ({ top: n(o.bottom), right: n(s - o.right) }),
      "bottom-right": () => ({ top: n(o.bottom), left: n(o.left) }),
      "left-top": () => ({ bottom: n(e - o.top - o.height), right: n(s - o.left) }),
      "left-bottom": () => ({ top: n(o.bottom - o.height), right: n(s - o.left) }),
      "right-top": () => ({ bottom: n(e - o.top - o.height), left: n(o.right) }),
      "right-bottom": () => ({ top: n(o.bottom - o.height), left: n(o.right) })
    }[i]();
  }, R = (t) => {
    const i = r.value;
    if (!i) return { coordinate: void 0, positioning: void 0 };
    const e = i.getBoundingClientRect(), s = L(e, t);
    return {
      coordinate: {
        top: e.top,
        left: e.left,
        height: e.height,
        width: e.width,
        bottom: e.bottom,
        right: e.right
      },
      positioning: s
    };
  }, $ = () => {
    const { positioning: t } = R(h.value);
    t && t && (b.value = {
      ...t,
      opacity: 1
    });
  }, w = (t, i) => {
    const e = t.getBoundingClientRect(), s = document.documentElement.clientHeight, o = document.documentElement.clientWidth;
    let p, g;
    return e.bottom + 300 < s ? g = "bottom" : g = "top", e.right + 200 < o ? p = "right" : p = "left", f ? `${p}-${g}` : `${g}-${p}`;
  }, d = c(!1), x = (t) => {
    if (!t) return [];
    const i = [];
    let e = t.parentElement;
    for (; e; )
      e.scrollHeight > e.clientHeight && i.push(e), e = e.parentElement;
    return i;
  }, m = c([]), E = () => {
    m.value = x(r.value), r.value && l.value && (h.value = w(r.value, l.value), $());
  };
  y(() => {
    !r.value || !l.value || w(r.value, l.value);
  });
  const k = () => {
    d.value = !0;
  }, H = () => {
    d.value ? a() : k();
  };
  v(d, (t) => {
    t && z(() => E());
  });
  const a = () => {
    d.value = !1, u && u();
  }, C = (t) => {
    if (!l.value)
      throw new Error('Parent component must have ref="targetRef"');
    return t.isSameNode(l.value) ? !0 : t.parentElement ? C(t.parentElement) : !1;
  };
  S(r, (t) => {
    try {
      C(t.target) || a();
    } catch {
      a();
    }
  });
  const P = c([]), M = (...t) => {
  };
  v(m, (t) => {
    t.forEach((i) => {
      P.value.push(new B(i, a, M));
    });
  }), y(() => {
    window.addEventListener("resize", a);
  });
  const O = () => {
    window.removeEventListener("resize", a), P.value.forEach((t) => {
      t.destroy();
    });
  };
  return N(() => {
    O();
  }), {
    targetRef: r,
    popoverRef: l,
    position: h,
    computedStylePopover: b,
    checkPositioning: E,
    openMenu: k,
    hideMenu: a,
    toggleMenu: H,
    scrollableParent: m,
    opened: d
  };
};
export {
  j as u
};
